import { useDispatch } from "react-redux";

import { PatientInsurance } from "pwapi";

import { deleteInsurance } from "shared/actions/admin/adminPatientActions";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";

import WarningDialog from "../WarningDialog";

type InsuranceWarningDialogProps = {
  insurance: PatientInsurance;
  onCompleteDeletion?: Function;
  onClose: Function;
};

const InsuranceWarningDialog = ({
  insurance,
  onCompleteDeletion,
  onClose,
}: InsuranceWarningDialogProps) => {
  const dispatch = useDispatch();

  const onDeleteInsurance = () => {
    insurance.id &&
      dispatch(
        deleteInsurance({
          id: insurance.id,
          onClose: onCompleteDeletion || onClose,
        })
      );
  };

  return (
    <WarningDialog onClose={() => onClose()} title="Delete Insurance">
      <div className="CaseWarningDialog">
        <span>Would you like to delete this insurance?</span>
        <span style={{ alignSelf: "center" }}>
          {insurance.insurance_company_name}
          <br />
          {insurance.policy_number}
        </span>
        <div className="actions__container">
          <PathologyWatchButton onClick={() => onClose()}>
            Cancel
          </PathologyWatchButton>
          <PathologyWatchButton
            type="submit"
            color="red"
            onClick={() => {
              onDeleteInsurance();
            }}
          >
            Delete
          </PathologyWatchButton>
        </div>
      </div>
    </WarningDialog>
  );
};

export default InsuranceWarningDialog;
